<div class="home-container">
  <!-- Header Section -->
  <div class="home-header">
    <div class="header-content">
      <div class="welcome-section">
        <h2 class="welcome-title">Welcome Back!</h2>
        <p class="welcome-subtitle">Manage your orders and track your revenue</p>
      </div>

      <!-- Navigation Pills -->
      <div class="nav-section">
        <ul class="nav nav-pills modern-nav">
          <li class="nav-item">
            <a [routerLink]="['orders']" routerLinkActive="active" class="nav-link">
              <i class="fa fa-clipboard-list"></i>
              <span>Orders</span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['revenue']" routerLinkActive="active" class="nav-link">
              <i class="fa fa-chart-line"></i>
              <span>Revenue</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Buzz Notification Alert -->
    <div class="buzz-alert-container" *ngIf="buzzNotification !== null">
      <!-- Desktop Buzz Alert -->
      <div class="buzz-alert buzz-alert-desktop d-none d-md-block">
        <div class="buzz-content">
          <div class="buzz-icon">
            <i class="fa fa-bolt"></i>
          </div>
          <div class="buzz-text">
            <span class="buzz-message">{{ buzzNotification }}</span>
            <span class="buzz-label">Customer needs attention</span>
          </div>
          <button class="buzz-action-btn" (click)="open(content)">
            <i class="fa fa-eye"></i>
            View
          </button>
        </div>
      </div>

      <!-- Mobile Buzz Alert -->
      <div class="buzz-alert buzz-alert-mobile d-block d-md-none">
        <button class="buzz-mobile-btn" (click)="open(content)">
          <div class="buzz-mobile-content">
            <i class="fa fa-bolt buzz-mobile-icon"></i>
            <span class="buzz-mobile-text">A customer needs your attention</span>
          </div>
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="home-content">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- Customer Buzz Modal -->
<ng-template let-modal #content>
  <div class="modern-modal buzz-modal">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="modal-title-section">
        <div class="modal-icon buzz-modal-icon">
          <i class="fa fa-bolt"></i>
        </div>
        <div class="modal-title-text">
          <h3 class="modal-title">Customer Buzz Alert</h3>
          <p class="modal-subtitle">A customer requires your immediate attention</p>
        </div>
      </div>
      <button type="button" class="modal-close-btn" (click)="modal.dismiss('Cross click')">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <div class="buzz-details">
        <div class="buzz-info-card">
          <div class="buzz-info-header">
            <h4 class="table-name">{{ buzzNotification?.table }}</h4>
            <span class="buzz-type">Customer Buzz</span>
          </div>
          <div class="buzz-reason">
            <label>Reason:</label>
            <span class="reason-text">{{ buzzNotification?.reason }}</span>
          </div>
          <div class="buzz-timestamp">
            <i class="fa fa-clock"></i>
            <span>Just now</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button type="button" class="btn-secondary" (click)="modal.dismiss('cancel')">
        <i class="fa fa-times"></i>
        Dismiss
      </button>
      <button class="btn-chat" type="button">
        <i class="fa fa-comments"></i>
        Chat Customer
      </button>
      <button class="btn-primary" (click)="settime(content2)">
        <i class="fa fa-clock"></i>
        Set Wait Time
      </button>
    </div>
  </div>
</ng-template>

<!-- Wait Time Modal -->
<ng-template let-modal #content2>
  <div class="modern-modal wait-time-modal">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="modal-title-section">
        <div class="modal-icon wait-time-icon">
          <i class="fa fa-clock"></i>
        </div>
        <div class="modal-title-text">
          <h3 class="modal-title">Set Wait Time</h3>
          <p class="modal-subtitle">How long should the customer wait?</p>
        </div>
      </div>
      <button type="button" class="modal-close-btn" (click)="modal.dismiss('Cross click')">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <div class="wait-time-section">
        <div class="time-selector">
          <button class="time-btn decrease-btn" (click)="minus()" type="button">
            <i class="fa fa-minus"></i>
          </button>

          <div class="time-display">
            <input type="number"
                   [(ngModel)]="minutes"
                   class="time-input"
                   min="1"
                   max="120">
            <span class="time-unit">minutes</span>
          </div>

          <button class="time-btn increase-btn" (click)="plus()" type="button">
            <i class="fa fa-plus"></i>
          </button>
        </div>

        <div class="time-presets">
          <button class="preset-btn" (click)="setMinutes(5)" [class.active]="minutes === 5">5 min</button>
          <button class="preset-btn" (click)="setMinutes(10)" [class.active]="minutes === 10">10 min</button>
          <button class="preset-btn" (click)="setMinutes(15)" [class.active]="minutes === 15">15 min</button>
          <button class="preset-btn" (click)="setMinutes(20)" [class.active]="minutes === 20">20 min</button>
        </div>

        <div class="estimated-time">
          <i class="fa fa-info-circle"></i>
          <span>Customer will be notified of the wait time</span>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button type="button" class="btn-secondary" (click)="modal.dismiss('cancel')">
        <i class="fa fa-times"></i>
        Cancel
      </button>
      <button class="btn-primary" (click)="update()">
        <i class="fa fa-check"></i>
        Confirm Wait Time
      </button>
    </div>
  </div>
</ng-template>
